import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import * as styles from './styles';
import { PopupProviderProps } from './models';

export const providerId = 'popup_provider';

export const PopupProvider = styled(({ className, children }: PopupProviderProps) => (
  <div {...{ id: providerId, className: classNames(className, 'popup-provider-wrapper') }}>{children}</div>
))`
  ${styles.PopupProvider}
`;

export { openPortalTag } from './styles';
